import { createIcon } from '@chakra-ui/react';

export const PeopleBoldIcon = createIcon({
  displayName: 'PeopleBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="25"
        // height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M18.0291 7.77C17.9591 7.76 17.8891 7.76 17.8191 7.77C16.2691 7.72 15.0391 6.45 15.0391 4.89C15.0391 3.3 16.3291 2 17.9291 2C19.5191 2 20.8191 3.29 20.8191 4.89C20.8091 6.45 19.5791 7.72 18.0291 7.77Z"
          fill="#6E6789"
        />
        <path
          d="M21.2896 14.7004C20.1696 15.4504 18.5996 15.7304 17.1496 15.5404C17.5296 14.7204 17.7296 13.8104 17.7396 12.8504C17.7396 11.8504 17.5196 10.9004 17.0996 10.0704C18.5796 9.8704 20.1496 10.1504 21.2796 10.9004C22.8596 11.9404 22.8596 13.6504 21.2896 14.7004Z"
          fill="#6E6789"
        />
        <path
          d="M6.94016 7.77C7.01016 7.76 7.08016 7.76 7.15016 7.77C8.70016 7.72 9.93016 6.45 9.93016 4.89C9.93016 3.29 8.64016 2 7.04016 2C5.45016 2 4.16016 3.29 4.16016 4.89C4.16016 6.45 5.39016 7.72 6.94016 7.77Z"
          fill="#6E6789"
        />
        <path
          d="M7.05109 12.8496C7.05109 13.8196 7.26109 14.7396 7.64109 15.5696C6.23109 15.7196 4.76109 15.4196 3.68109 14.7096C2.10109 13.6596 2.10109 11.9496 3.68109 10.8996C4.75109 10.1796 6.26109 9.88962 7.68109 10.0496C7.27109 10.8896 7.05109 11.8396 7.05109 12.8496Z"
          fill="#6E6789"
        />
        <path
          d="M12.6208 15.87C12.5408 15.86 12.4508 15.86 12.3608 15.87C10.5208 15.81 9.05078 14.3 9.05078 12.44C9.06078 10.54 10.5908 9 12.5008 9C14.4008 9 15.9408 10.54 15.9408 12.44C15.9308 14.3 14.4708 15.81 12.6208 15.87Z"
          fill="#6E6789"
        />
        <path
          d="M9.37078 17.9396C7.86078 18.9496 7.86078 20.6096 9.37078 21.6096C11.0908 22.7596 13.9108 22.7596 15.6308 21.6096C17.1408 20.5996 17.1408 18.9396 15.6308 17.9396C13.9208 16.7896 11.1008 16.7896 9.37078 17.9396Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
